import logo from "../../../assets/Form/bwllogo.png";
import phoneIcon from "../../../assets/Form/phone.svg";

export default function Navbar() {
  return (
    <header className="bg-white px-5 py-5 sm:px-14">
      <div className="mx-auto flex max-w-[1320px] items-center justify-between">
        <img src={logo} alt="Be With Law" className="h-6 sm:h-7" />
        <a href="tel:8882021350" className="hidden items-center rounded-full bg-[#0A1F8F] px-3 py-2 sm:flex">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#F8D216]"><img src={phoneIcon} alt="" className="h-4 w-4" /></span>
          <span className="ml-3 text-left font-lato font-bold text-white"><small className="block text-[10px] tracking-wide text-[#F8D216]">CALL US NOW</small><span className="block text-[16px] leading-5">(888) 202-1350</span></span>
        </a>
        <a className="text-sm font-bold text-[#0A1F8F] sm:hidden" href="tel:8882021350">Call us now</a>
      </div>
    </header>
  );
}
